<template>
  <div class="ma-2 ml-3 site_content">
    <div class="header flex">
      <button class="header-button mr-2 main" @click="gotoSummary()">
        ◀︎ 제어현황
      </button>

      <button class="header-button gray" @click="showHistories()"
        id="histories"
        ref="histories"
        :loading="historiesloading">
        {{historiesBtnText}}
      </button>
    </div>

    <div v-if="loadingInfoDetail" class="loading-monitor-container">
      <div class="spinner"></div>
    </div>


    <div class="set-container flex" v-else>
      <div class="status-container">
        <div class="room-info" :class="getRoomClass()">
          <div class="text_name" :class="getTextClass()"> 
            <span>{{room_name}}</span>
            <span class="text_staus"> {{auto_mode}} </span>

            <div class="flex">
              <img class="box_temp" :src="icon_controltemp" :class="getIconClass()"/>
              <div>
                <div class="temp">
                  <span class="text_temp mr-2">온도/습도</span>
                  <span class="text_number">{{temp}}</span>
                  <span class="text_number_unit"> ℃ /</span>
                  <span class="text_number ml-1">{{hum}}</span>
                  <span class="text_number_unit"> %</span>
                </div>

                <div class="feel">
                  <span class="text_feel">체감온도</span>
                  <span class="text_number">{{feel}}</span>
                  <span class="text_number_unit"> ℃ </span>
                </div>
              </div>
            </div>

            <div class="fan-info">
              <div class="set_info">
                <div class="name">
                  <v-icon color=#3a4f3f size="20">
                      mdi-fan
                  </v-icon>
                  팬
                </div>
                <div class="detail_info">
                  <div class="text_info"> 목표온도 : {{pannel.set_temp}}</div>
                  <div class="text_info">온도편차 : {{pannel.dev_temp}}</div>
                </div>
              </div>
             
              <div class="set_info" v-if="pannel.set_temp1">
                <div class="name">보온등</div>
                <div class="detail_info">
                  <div class="text_info"> 목표온도 : {{pannel.set_temp1 }}</div>
                  <div class="text_info"> 온도편차 : {{pannel.dev_temp1}}</div>
                </div>
              </div>

              <div style=" padding:15px 15px 0 15px;">
                <div style="display:flex;">
                  <div class="name">현재출력</div>
                  <div class="text_info"> ID | 1차 / 2차 / 3차 %</div>
                </div>
              </div>

              <div class="detail_info" >
                
                  <!-- <div class="text_info"> ID | 1차 / 2차 / 3차 %</div> -->
                  <div v-for="fan_list in pannel.now_list" :key="fan_list.slave_id">
                    <div style="display:flex;">
                      
                      <div style="display:flex;">
                        <div v-if="fan_list.now_vent === `-∕-∕-` " style="width:82px;"></div>

                        <div class="fc" v-if="fan_list.now_vent1 !== '-'">
                          <img :src="icon_fancontrol" v-if="fan_list.now_vent1 == 0" />
                          <img :src="icon_fancontrol" v-else :style="{ '--animation-duration' : (2 - (fan_list.now_vent1 / 100 * 1.9))  + 's' }" class="test_vent" />
                        </div>
                        <div class="fc ml-1" v-if="fan_list.now_vent2 !== '-'">
                          <img :src="icon_fancontrol" v-if="fan_list.now_vent2 == 0" />
                          <img :src="icon_fancontrol" v-else :style="{ '--animation-duration' : (2 - (fan_list.now_vent2 / 100 * 1.9))  + 's' }" class="test_vent" />
                        </div>
                        <div class="fc ml-1" v-if="fan_list.now_vent3 !== '-'">
                          <img :src="icon_fancontrol" v-if="fan_list.now_vent3 == 0" />
                          <img :src="icon_fancontrol" v-else :style="{ '--animation-duration' : (2 - (fan_list.now_vent3 / 100 * 1.9))  + 's' }" class="test_vent" />
                        </div>
                      </div>
                      <div class="text_inf ml-4"> 
                        <span class="mr-1">{{fan_list.slave_id}}</span>  |  
                        <span class="ml-2">{{fan_list.now_vent}} </span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="set_info">
                  <div class="name" >
                    주령
                  </div>
                  <div class="detail_info">
                    <div class="text_info"> {{week_age}} 주</div>
                  </div>
                </div>

                <div class="set_info">
                  <div class="name">
                    환기량
                  </div>
                  <div class="detail_info">
                    <div class="text_info"> - </div>
                  </div>
                </div>
              </div>

              <div class="control_date">적용일시:
                <span class="enter_date">{{setdate}}</span>
              </div>
            </div>
          </div>
          
          <div class="control-set" :loading="loadingInfoDetail">
            <div class="set_mode">
              <div class="set_select">
                <v-radio-group dense outlined row @change="changeValue()"
                  id="remote_mode"
                  v-model="remote_mode">
                  <template v-slot:label>
                    <div class="set_name"> 제어모드 </div>
                  </template>
                  <v-radio ref="remote1" label="수동" value="1" color="#005B96"/>
                  <v-radio ref="remote2" label="계절" value="2" color="#005B96"/>    
                </v-radio-group>
              </div>
            </div>

            <div class="set_mode">
              <div class="set_name">제어기준지표</div>
              <div class="set_select">
                <v-select dense outlined class="selectbox shrink" @change="changeValue()"
                  id="control_stand"
                  ref="control_stand"
                  v-model="control_stand"
                  :items="standardItems"
                  :menu-props="{top:false, offsetY:true}"
                  no-data-text="권한이 없습니다."
                  item-text="name"
                  return-object/>
              </div>
            </div>

            <div class="set_mode" v-show="remote_mode === '2'">
              <div class="set_name">체중구간</div>
              <div class="set_select">
              <v-select dense outlined class="selectbox shrink" @change="changeValue()"
                id="weight_section"
                ref="weight_section"
                v-model="weight_section"
                :items="weightItems"
                :menu-props="{top:false, offsetY:true}"
                no-data-text="자료(권한)이 없습니다."
                item-text="name"
                return-object
                @focus="weightSets()"/>
            </div>
          </div>

          <div class="set_mode">
            <div class="set_name">출생일</div>
              <div class="set_select">
              <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="10"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field dense outlined clearable class="selectbox-cal shrink" @change="changeValue()"
                  id="birth" 
                  ref="birth" 
                  v-model="birth"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title locale="ko-KR"
                v-model="birth"
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
            </div>
          </div>

          <v-textarea class="ml-2 mr-2" outlined dense rows="2" name="input-7-4" @change="changeValue()"
            label="비고"
            id="history" 
            ref="history" 
            v-model="history"
            value=""
          ></v-textarea>
          </div>
        </div>
        
        <div class="setting-containter">
          <v-form id="remoteSet">
            <div v-for="(fan_list,i) in fan_list" :key="i">
              <!-- {{ fan_list }} -->
              <div class="flex mt-3">
                <div class="line mr-2"></div>
                <div class="fan-name">팬컨트롤러 {{i + 1}}</div>
              </div>

              <div dense class="error_overlay" v-show="fan_list.set_temp === '-∕-∕-'">
                <div class="dialog">
                  <div class="dialog_title">
                    <v-icon color="#005B96">mdi-lan-disconnect</v-icon>
                    팬컨트롤러 {{i + 1}} 통신 장애
                  </div>
                  <div class="dialog_cotent">
                    팬 컨트롤러 데이터 수신이 지연되고 있습니다. <br/>
                    다시 시도하려면 화면을 새로고침하거나 재접속해 주세요.
                  </div>
                  <div>
                    <button class="error_btn" type="button"
                    @click="$router.go(-1);">
                      제어현황
                    </button>
                  </div>
                </div>
              </div>

              <div dense class="fc_setbox">
                <div class="vent-name ml-2"> 1차 </div>
                <div class="flex vertical-center mb-vent">
                  <v-text-field dense outlined   @change="changeValue()"
                  type="number"
                  id="min_vent1"
                  ref="min_vent1"
                  class="input-box centered-input shrink"
                  label="최소출력"
                  min="0"
                  max="99"
                  :disabled="remote_mode!=='1' || fan_list.set_temp === '-∕-∕-'"
                  v-model="fan_list.min_vent1"
                  oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"
                  >                
              </v-text-field>

              <v-text-field dense outlined  @change="changeValue()"
                  type="number"
                  id="max_vent1"
                  ref="max_vent1"
                  class="input-box centered-input shrink"
                  label="최대출력"
                  min="0"
                  max="99"
                  :disabled="remote_mode!=='1' || fan_list.set_temp === '-∕-∕-'"
                  oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"
                  v-model="fan_list.max_vent1"/>

              <v-text-field dense outlined @change="changeValue()"
                  type="number"
                  id="set_temp1"
                  ref="set_temp1"
                  class="input-box centered-input  shrink"
                  label="설정온도"
                  min="15"
                  max="33"
                  oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"
                  :disabled="remote_mode!=='1' || fan_list.set_temp === '-∕-∕-'"
                  v-model="fan_list.set_temp1"/>

              <v-text-field dense outlined @change="changeValue()"
                  type="number"
                  id="dev_temp1"
                  ref="dev_temp1"
                  class="input-box centered-input shrink"
                  label="온도편차"
                  min="0"
                  max="10"
                  oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"
                  :disabled="remote_mode!=='1' || fan_list.set_temp === '-∕-∕-'"
                  v-model="fan_list.dev_temp1"/>
                </div>
              </div>

              <div dense class="fc_setbox">
                <div class="vent-name ml-2"> 2차 </div>
                <div class="flex vertical-center mb-vent">
                  <v-text-field dense outlined @change="changeValue()"
                    type="number"
                    id="min_vent2"
                    ref="min_vent2"
                    class="input-box centered-input mr-3 shrink" style="margin-bottom: -12px;"
                    label="최소출력"
                    min="0"
                    max="99"
                    :disabled="remote_mode!=='1'  || fan_list.set_temp === '-∕-∕-' "
                    oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"
                    v-model="fan_list.min_vent2">                    
                </v-text-field>

                <v-text-field dense outlined @change="changeValue()"
                    type="number"
                    id="max_vent2"
                    ref="max_vent2"
                    class="input-box centered-input mr-3 shrink" style="margin-bottom: -12px;"
                    label="최대출력"
                    min="0"
                    max="99"
                    :disabled="remote_mode!=='1' || fan_list.set_temp === '-∕-∕-'"
                    oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"
                    v-model="fan_list.max_vent2"/>

                <v-text-field dense outlined @change="changeValue()"
                    type="number"
                    id="set_temp2"
                    ref="set_temp2"
                    class="input-box centered-input mr-3 shrink" style="margin-bottom: -12px;"
                    label="설정온도"
                    min="15"
                    max="33"
                    oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"
                    :disabled="remote_mode!=='1' || fan_list.set_temp === '-∕-∕-'"
                    v-model="fan_list.set_temp2"/>

                <v-text-field dense outlined @change="changeValue()"
                    type="number"
                    id="dev_temp2"
                    ref="dev_temp2"
                    class="input-box centered-input mr-5 shrink" style="margin-bottom: -12px;"
                    label="온도편차"
                    min="0"
                    max="10"
                    oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"
                    :disabled="remote_mode!=='1' || fan_list.set_temp === '-∕-∕-'"
                    v-model="fan_list.dev_temp2"/>
                </div>
              </div>

              <div dense class="fc_setbox">
                <div class="vent-name ml-2"> 3차 </div>
                <div class="flex vertical-center mb-vent">
                  <v-text-field dense outlined @change="changeValue()"
                  type="number"
                  id="min_vent3"
                  ref="min_vent3"
                  class="input-box centered-input mr-3 shrink" style="margin-bottom: -12px;"
                  label="최소출력"
                  min="0"
                  max="99"
                  :disabled="remote_mode!=='1' || fan_list.set_temp === '-∕-∕-'"
                  oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"
                  v-model="fan_list.min_vent3">                    
              </v-text-field>

              <v-text-field dense outlined @change="changeValue()"
                  type="number"
                  id="max_vent3"
                  ref="max_vent3"
                  class="input-box centered-input mr-3 shrink" style="margin-bottom: -12px;"
                  label="최대출력"
                  min="0"
                  max="99"
                  :disabled="remote_mode!=='1' || fan_list.set_temp === '-∕-∕-'"
                  oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"
                  v-model="fan_list.max_vent3"/>

              <v-text-field dense outlined @change="changeValue()"
                  type="number"
                  id="set_temp3"
                  ref="set_temp3"
                  class="input-box centered-input mr-3 shrink" style="margin-bottom: -12px;"
                  label="설정온도"
                  min="15"
                  max="33"
                  oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"
                  :disabled="remote_mode!=='1' || fan_list.set_temp === '-∕-∕-'"
                  v-model="fan_list.set_temp3"/>

              <v-text-field dense outlined @change="changeValue()"
                  type="number"
                  id="dev_temp3"
                  ref="dev_temp3"
                  class="input-box centered-input mr-5 shrink" style="margin-bottom: -12px;"
                  label="온도편차"
                  min="0"
                  max="10"
                  oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"
                  :disabled="remote_mode!=='1' || fan_list.set_temp === '-∕-∕-'"
                  v-model="fan_list.dev_temp3"/>
                </div>
              </div>
            </div>

            <div v-for="(lamp_list,a) in lamp_list" :key="a + lamp_list.length">
              <div class="flex mt-10">
                <div class="line mr-2" style="margin-bottom: 5px;"></div>
                <div class="fan-name">
                  보온등 {{a+1}}
                </div>
                <div class="switch-container ml-5">
                  <label class="switch">
                    <input type="checkbox" v-model="lamp_list.on_off1" >
                    <span class="slider"></span>
                  </label>
                </div>
              </div>

              <div dense class="fc_setbox" v-show="lamp_list.on_off1 == true ">
                <div class="vent-name ml-2"> 1차 </div> 
                <div class="flex vertical-center">
                  <v-text-field dense outlined @change="changeValue()"
                      type="number"
                      id="min_vent1"
                      ref="min_lamp1"
                      class="input-box centered-input mr-3 shrink" style="margin-bottom: -12px;"
                      label="최소출력"
                      min="0"
                      max="99"
                      :disabled="remote_mode!=='1'"
                      oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"
                      v-model="lamp_list.min_vent1"/>

                  <v-text-field dense outlined @change="changeValue()"
                      type="number"
                      id="max_vent1"
                      ref="max_lamp1"
                      class="input-box centered-input mr-3 shrink" style="margin-bottom: -12px;"
                      label="최대출력"
                      min="0"
                      max="99"
                      :disabled="remote_mode!=='1'"
                      oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"
                      v-model="lamp_list.max_vent1"/>

                  <v-text-field dense outlined @change="changeValue()"
                      type="number"
                      id="set_temp1"
                      ref="set_lamp1"
                      class="input-box centered-input mr-3 shrink" style="margin-bottom: -12px;"
                      label="설정온도"
                      min="15"
                      max="33"
                      oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"
                      :disabled="remote_mode!=='1'"
                      v-model="lamp_list.set_temp1"/>

                  <v-text-field dense outlined @change="changeValue()"
                      type="number"
                      id="dev_temp1"
                      ref="dev_lamp1"
                      class="input-box centered-input mr-5 shrink" style="margin-bottom: -12px;"
                      label="온도편차"
                      :disabled="remote_mode!=='1'"
                      min="0"
                      max="10"
                      oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"
                      v-model="lamp_list.dev_temp1"/>
                  </div>
              </div>
            </div>


            <div class="flex vertical-center mt-5 btn-container">
              <button outlined class="exit_btn rounded-pill mr-3 "
                type="button"
                id="exit"
                ref="exit"
                style="height:45px; width:90px; font-size:17px;"
                @click="$router.go(-1);"
                >
                취소
              </button>
              <button
                outlined class="save_btn rounded-pill mr-3 "
                v-if="this.$getters.userInfo.grade < 'UT06' && this.fan_list.length !== 0 && !this.fan_list.some(fan => fan.set_temp === '-∕-∕-')  "
                type="button"
                :loading="loadingSave"
                id="save"
                ref="save"
                style="height:45px; width:90px; font-size:17px;"
                @click="saveControl()">
                적용
              </button>
              <button v-if="$getters.userInfo.grade < 'UT06'" outlined class="stop_btn rounded-pill mr-3 " v-show="pre_mode > 0"
                type="button"
                id="stop"
                ref="stop"
                style="height:45px; width:90px; font-size:17px;"
                @click="stopControl();"
                >
                제어중단
              </button>
            </div>
          </v-form>
        </div>

        <div class="history-container"  v-show="showhistories">
          <div class="flex mt-3">
            <div class="line mr-2"></div>
            <div class="fan-name">제어이력</div>
          </div>

          <div class="table_layout">
            <v-data-table dense class="table_content"
              :loading="historiesloading"
              id="items" 
              ref="items"
              :headers="headers"
              :items="items"
              :items-per-page= "100"
              no-data-text="등록된 자료가 없습니다.  "
              fixed-header
              height="auto"
              hide-default-footer
              item-key="id"
              single-select
              @click:row="infoSetting"
              :item-class="itemRowBackground"
            >
            <!-- eslint-disable-next-line -->
            <template v-slot:item.daily_range_yn="{ item }">
              <span>{{ item.daily_range_yn == 'Y' ? 'ON' : 'OFF' }}</span>
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.daily_range="{ item }">
              <span>{{ item.daily_range_yn == 'Y' ? item.daily_range : 'N/A' }}</span>
            </template>
          
          
            </v-data-table>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import Apis from '@/api/apis';
import Common from "@/utils/custom/common.js";
import dateUtil from "@/utils/custom/dateProperty.js";
// import VueCookies from "vue-cookies";

export default{
  name:"ControlSet",

  async created(){
      Apis.pageCount({ //페이지뷰 카운터
        page_name: this.$route.name,
        url: this.$route.path,
        division: "cloud",
      },() => {  // 정상처리
        // console.log("pageCount 호출",res);
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("pageCount 호출 오류",err);
      });
      // console.log(this.$route.params.room)
      if (!this.$route.params.room) {
        this.$router.push({
          name: "ControlMonitoring",
        });
        return;
      }
      await this.weightSets();
      await this.infoDetail();
      // this.listHistories();
  },
  data : () => ({
    icon_controltemp_white: require("@/assets/barometer/icon_controltemp_white.svg"),
    icon_controltemp: require("@/assets/barometer/icon_controltemp.svg"),

    icon_fancontrol: require("@/assets/control/fan_control.svg"),

    now_vent:95,
    now_vent2:40,
    now_vent3:20,

    company_cd:"",farm_cd:"",building_cd: "",building_name: "",room_cd:"",    // 키값 No show
    company_name:"",farm_name:"",    // 키값 No show
    room_name:"",
    pannel:{},
    auto_mode:"",
    pre_mode: 0,
    temp:"",
    hum:"",
    feel:"",
    setdate:"",
    week_age:"",
    birth:"",
    menu1:false,

    enter_date:"",
    history:"",

    remote_mode:"",

    daily_range_yn: "",
    daily_range:"",

    fan_list:[{set_temp:"",dev_temp:""}],
    lamp_list:[{set_temp:"",dev_temp:""}],

    control_stand:{},
    standardItems : Common.comboBaseCode("DN"),

    weight_section:{},
    weightItems: [],
    control_status:0,

    items: [],
    headers: [
      { text: '적용일', sortable: false, align: 'center', value: 'setdate', width: "200px", groupable: false,},
      { text: '제어모드', sortable: false, align: 'center', value: 'control_status_text', width: "100px", groupable: false},
      { text: '등록자', sortable: false, align: 'center', value: 'reguser', width: "200px", groupable: false},
      // { text: '비고', sortable: false, align: 'start', value: 'history', width: "200px" , groupable: false, class: 'green darken-4 white--text'},
    ],
    loadingInfoDetail:false,
    historiesloading:false,
    showhistories:false,
    historiesBtnText: "이력보기",
    save_id:0,
    loadingSave:false, 

    isErrorOpen:false,
    saveBtn:true,

  }),

  methods : {
    changeValue(){
      this.$store.commit("resMessage","");
    },
    async weightSets(){
      await Apis.comboWeightRanges({
        building_cd: this.$route.params.building.code,
        },(res) => {  
          if (res.result) {
            this.weightItems = res.data;
          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("comboWeightRanges API 호출 오류",err)
        }
      )
    },
    clearData() {
      this.remote_mode = "";
      this.pre_mode = 0;
      this.control_stand = {};
      this.weight_section = {};
      // this.daily_range_yn = "";
      this.birth = "";
      this.history = "";
    }, 
    checkData() {
      if (this.remote_mode < "1") {
        this.$refs.remote1.$el.children[1].focus()
        // this.$refs.control_stand.focus();
        return "제어모드를 선택하세요";
      }
      if (!this.control_stand.code) {
        this.$refs.control_stand.focus();
        return "제어기준지표를 선택하세요";
      }
      if (this.remote_mode == "2") {
        if (!this.weight_section.code) {
          this.$refs.weight_section.focus();
          return "체중구간을 선택하세요";
        }
      }
      if (this.remote_mode == "1") {
        for (let i in this.fan_list) {
          // console.log(i,this.fan_list[i].max_vent1);
          if (!Common.isInteger(this.fan_list[i].max_vent1) || this.fan_list[i].max_vent1 < 0 || this.fan_list[i].max_vent1 > 99 ) {
            this.$refs.max_vent1[i].focus();
            return "정확한 정수 값만 입력하세요(0~99)";
          }
          if (!Common.isInteger(this.fan_list[i].max_vent2) || this.fan_list[i].max_vent2 < 0 || this.fan_list[i].max_vent2 > 99 ) {
            this.$refs.max_vent2[i].focus();
            return "정확한 정수 값만 입력하세요(0~99)";
          }
          if (!Common.isInteger(this.fan_list[i].max_vent3) || this.fan_list[i].max_vent3 < 0 || this.fan_list[i].max_vent3 > 99 ) {
            this.$refs.max_vent3[i].focus();
            return "정확한 정수 값만 입력하세요(0~99)";
          }
          if (!Common.isInteger(this.fan_list[i].min_vent1) || this.fan_list[i].min_vent1 < 0 || this.fan_list[i].min_vent1 > 99 ) {
            this.$refs.min_vent1[i].focus();
            return "정확한 정수 값만 입력하세요(0~99)";
          }
          if (!Common.isInteger(this.fan_list[i].min_vent2) || this.fan_list[i].min_vent2 < 0 || this.fan_list[i].min_vent2 > 99  ) {
            this.$refs.min_vent2[i].focus();
            return "정확한 정수 값만 입력하세요(0~99)";
          }
          if (!Common.isInteger(this.fan_list[i].min_vent3) || this.fan_list[i].min_vent3 < 0 || this.fan_list[i].min_vent3 > 99 ) {
            this.$refs.min_vent3[i].focus();
            return "정확한 정수 값만 입력하세요(0~99)";
          }
          if (this.fan_list[i].min_vent1 > this.fan_list[i].max_vent1) {
            this.$refs.min_vent1[i].focus();
            return "최소 환기값은 최대 환기값보다 높을 수 없습니다.";
          }
          if (this.fan_list[i].min_vent2 > this.fan_list[i].max_vent2) {
            this.$refs.min_vent2[i].focus();
            return "최소 환기값은 최대 환기값보다 높을 수 없습니다.";
          }
          if (this.fan_list[i].min_vent3 > this.fan_list[i].max_vent3) {
            this.$refs.min_vent3[i].focus();
            return "최소 환기값은 최대 환기값보다 높을 수 없습니다.";
          }
          if (!Common.isInteger(this.fan_list[i].set_temp1) || this.fan_list[i].set_temp1 < 15 || this.fan_list[i].set_temp1 > 33) {
            this.$refs.set_temp1[i].focus();
            return "정확한 정수 값만 입력하세요(15~33)";
          }
          
          if(Number(this.fan_list[i].set_temp1) + Number(this.fan_list[i].dev_temp1) > 33 ){
            // console.log(Number(this.fan_list[i].set_temp1) + Number(this.fan_list[i].dev_temp1))
            this.$refs.set_temp1[i].focus();
            return "설정 온도와 온도 편차의 합은 33 이하여야 합니다."
          }
          if(Number(this.fan_list[i].set_temp2) + Number(this.fan_list[i].dev_temp2) > 33 ){
            // console.log(Number(this.fan_list[i].set_temp2) + Number(this.fan_list[i].dev_temp2))
            this.$refs.set_temp2[i].focus();
            return "설정 온도와 온도 편차의 합은 33 이하여야 합니다."
          }
          if(Number(this.fan_list[i].set_temp3) + Number(this.fan_list[i].dev_temp3) > 33 ){
            // console.log(Number(this.fan_list[i].set_temp3) + Number(this.fan_list[i].dev_temp3))
            this.$refs.set_temp3[i].focus();
            return "설정 온도와 온도 편차의 합은 33 이하여야 합니다."
          }
        
          // 1차 온도 ≤ 2차 온도 ≤ 3차 온도
          if (
              Number(this.fan_list[i].set_temp1) > Number(this.fan_list[i].set_temp2) || 
              Number(this.fan_list[i].set_temp2) > Number(this.fan_list[i].set_temp3) ||
              Number(this.fan_list[i].set_temp1) > Number(this.fan_list[i].set_temp3)
          ) {
              if (Number(this.fan_list[i].set_temp1) > Number(this.fan_list[i].set_temp2)) {
                  this.$refs.set_temp1[i].focus();
              } else if (Number(this.fan_list[i].set_temp2) > Number(this.fan_list[i].set_temp3)) {
                  this.$refs.set_temp2[i].focus();
              } else {
                  this.$refs.set_temp1[i].focus(); // 1차 > 3차가 문제일 경우
              }
              return "1차 온도 ≤ 2차 온도 ≤ 3차 온도의 조건을 충족해야 합니다.";
          }


          if (!Common.isInteger(this.fan_list[i].set_temp2) || this.fan_list[i].set_temp2 < 15 || this.fan_list[i].set_temp2 > 33) {
            this.$refs.set_temp2[i].focus();
            return "정확한 정수 값만 입력하세요(15~33)";
          }
          if (!Common.isInteger(this.fan_list[i].set_temp3) || this.fan_list[i].set_temp3 < 15 || this.fan_list[i].set_temp3 > 33) {
            this.$refs.set_temp3[i].focus();
            return "정확한 정수 값만 입력하세요(15~33)";
          }
          if (!Common.isInteger(this.fan_list[i].dev_temp1) || this.fan_list[i].dev_temp1 < 0 || this.fan_list[i].dev_temp1 > 10) {
            this.$refs.dev_temp1[i].focus();
            return "정확한 정수 값만 입력하세요(0~10)";
          }
          if (!Common.isInteger(this.fan_list[i].dev_temp2) || this.fan_list[i].dev_temp2 < 0 || this.fan_list[i].dev_temp2 > 10) {
            this.$refs.dev_temp2[i].focus();
            return "정확한 정수 값만 입력하세요(0~10)";
          }
          if (!Common.isInteger(this.fan_list[i].dev_temp3) || this.fan_list[i].dev_temp3 < 0 || this.fan_list[i].dev_temp3 > 10) {
            this.$refs.dev_temp3[i].focus();
            return "정확한 정수 값만 입력하세요(0~10)";
          }
        }
      }
      if (this.lamp_list.on_off1 == true) {
        for (let i in this.lamp_list) {
          // console.log(i,this.fan_list[i].max_vent1);
          if (!Common.isInteger(this.lamp_list[i].max_vent1) || this.lamp_list[i].max_vent1 < 0 || this.lamp_list[i].max_vent1 > 99 ) {
            this.$refs.max_lamp1[i].focus();
            return "정확한 정수 값만 입력하세요(0~99)";
          }
          if (!Common.isInteger(this.lamp_list[i].min_vent1) || this.lamp_list[i].min_vent1 < 0 || this.lamp_list[i].min_vent1 > 99 ) {
            this.$refs.min_lamp1[i].focus();
            return "정확한 정수 값만 입력하세요(0~99)";
          }
          if (!Common.isInteger(this.lamp_list[i].set_temp1) || this.lamp_list[i].set_temp1 < 15 || this.lamp_list[i].set_temp1 > 33) {
            this.$refs.set_lamp1[i].focus();
            return "정확한 정수 값만 입력하세요(15~33)";
          }
          if (!Common.isInteger(this.lamp_list[i].dev_temp1) || this.lamp_list[i].dev_temp1 < 0 || this.lamp_list[i].dev_temp1 > 10) {
            this.$refs.dev_lamp1[i].focus();
            return "정확한 정수 값만 입력하세요(0~10)";
          }
          if (Number(this.lamp_list[i].set_temp1) + Number(this.lamp_list[i].dev_temp1) > 33) {
            this.$refs.set_lamp1[i].focus();
            return "설정 온도와 온도 편차의 합은 33 이하여야 합니다.";
          }
        }
      }
      return "";
    },
    saveControl(){
      this.$store.commit("resMessage","");
      let msgCheckdata = this.checkData(); 
      if (msgCheckdata){
        this.$store.commit("resMessage",msgCheckdata);
        // alert(msgCheckdata);
        return;
      }

      if (!confirm("설정변경 확인! \n 설정을 적용하시겠습니까?")) { return; }

      else {
        this.loadingSave = true;
        Apis.saveControllerSetting({
          company_cd: this.company_cd,
          farm_cd: this.farm_cd,
          building_cd: this.building_cd, building_name: this.building_name,
          room_cd: this.room_cd, 
          room_name: this.room_name,
          // fan_list: this.remote_mode && this.remote_mode == 1 && this.fan_list || [],
          // lamp_list: this.remote_mode && this.remote_mode == 1 && this.lamp_list || [],
          fan_list: this.fan_list,
          lamp_list: this.lamp_list,
          setdate: dateUtil.format(new Date(), "yyyy-MM-dd HH:mm:ss"),
          control_status: this.remote_mode && Number(this.remote_mode) || 0,
          control_stand: this.control_stand.code && this.control_stand.code || "",
          weight_range: this.remote_mode == "2" && this.weight_section && Number(this.weight_section.code) || 0,
          daily_range_yn: this.daily_range_yn || "",
          daily_range: this.daily_range && Number(this.daily_range) || 0,
          birthday: this.birth && this.birth || "",
          history: this.history && this.history.trim() || "",
          },(res) => {  
            if (res.result) {
              this.loadingSave = false;
              alert(res.message);
              this.$router.go(-1);
            } else {
              this.loadingSave = false;
              alert(res.message);
            }
          }).catch( (err) => {  // API 오류 처리
            this.loadingSave = false;
            console.log("saveControllerSetting API 호출 오류",err)
            this.$store.commit("resMessage","saveControllerSetting API 호출 오류");
          }
        ) 
      }
    },
    stopControl(){
      this.$store.commit("resMessage","");
      this.loadingSatop = true;
      if (!confirm("제어중단 확인! \n 중앙제어를 중단하고 현장제어로 적용하시겠습니까?")) { return; }
      else {

        Apis.saveControllerSetting({
          company_cd: this.company_cd,
          farm_cd: this.farm_cd,
          building_cd: this.building_cd, building_name: this.building_name,
          room_cd: this.room_cd, room_name: this.room_name,
          fan_list: this.fan_list,
          lamp_list: this.lamp_list,
          setdate: dateUtil.format(new Date(), "yyyy-MM-dd HH:mm:ss"),
          control_status: 0,
          control_stand: "",
          weight_range: 0,
          daily_range_yn: "",
          daily_range: 0,
          birthday: this.birth && this.birth || "",
          history: this.history && this.history.trim() || "",
          },(res) => {  
            if (res.result) {
              this.$router.go(-1);
            } else {
              alert(res.message);
            }
          }).catch( (err) => {  // API 오류 처리
            console.log("saveControllerSetting API 호출 오류",err)
            this.$store.commit("resMessage","saveControllerSetting API 호출 오류");
          }
        ) 
      }
    },

    async infoDetail(){
      this.loadingInfoDetail= true;
      Apis.infoDetailRoomControllers(
        {
          room_cd: this.$route.params.room.code,
          // room_cd: "R20007",
          stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
            if (res.result) {
              this.control_status = res.data.control_status;
              this.company_cd = res.data.company_cd; this.company_name = res.data.company_name;
              this.farm_cd = res.data.farm_cd; this.farm_name = res.data.farm_name;
              this.building_cd = res.data.building_cd; this.building_name = res.data.building_name;
              this.building_name = res.data.building_name;
              this.room_cd = res.data.room_cd;
              this.room_name = res.data.room_name;
              this.pannel = {
                              set_temp: res.data.fan_list[0].set_temp, dev_temp: res.data.fan_list[0].dev_temp,
                              set_temp1: res.data.lamp_list[0] && res.data.lamp_list[0].set_temp1 || "" ,
                              dev_temp1: res.data.lamp_list[0] && res.data.lamp_list[0].dev_temp1 || "" ,
                              now_list: res.data.fan_list,
                            };
              res.data.room_name;
              this.auto_mode = res.data.auto_mode;
              this.pre_mode = res.data.control_status;
              this.setdate = res.data.setdate.substring(0,19);
              this.remote_mode = res.data.control_status.toString();
              this.temp = res.data.temp;
              this.hum = res.data.hum;
              this.feel = res.data.feel;
              this.week_age = res.data.week_age;
              this.enter_date = res.data.enter_date;
              this.birth = res.data.birthday;
              // this.history = res.data.history;

              this.control_stand = res.data.control_stand; 
              this.weight_section = res.data.weight_range;

              // this.daily_range_yn = res.data.daily_range_yn;
              // this.daily_range = res.data.daily_range;
              
              this.fan_list = res.data.fan_list;
              this.lamp_list = res.data.lamp_list && res.data.lamp_list || [];
              this.loadingInfoDetail= false;
          } else {  
              this.loadingInfoDetail= false;
              alert(res.message);
            }
            // console.log(this.pannel.now_list);
          }
        ).catch( (err) => {  // API 오류 처리
            this.loadingInfoDetail= false;
            this.$router.push({
              name: "ControlMonitoring",
            });
            console.log("API 호출 오류",err)
            // alert(err);
        }
      ) 
    },
    infoSetting(value,row) {
      if (value.control_status !== 1) return;
      row && row.select(true);
      this.$store.commit("resMessage","");
      this.loadinginfoDetail = true;
      this.clearData();
      Apis.infoSettingHistory({
        id: value.id, 
        },(res) => {  
          if (res.result) {
            this.remote_mode = res.data.control_status.toString();
            this.birth = res.data.birthday;
            this.control_stand = res.data.control_stand; 
            this.weight_section = res.data.weight_range;

            // this.daily_range_yn = res.data.daily_range_yn;
            // this.daily_range = res.data.daily_range;
            this.history = res.data.history;
            
            this.fan_list = res.data.fan_list;
            this.lamp_list = res.data.lamp_list;
            
            this.loadinginfoDetail = false;
            this.$store.commit("resMessage",`${res.data.setdate} 수동세팅 내용입니다.`);
            window.scrollTo(0,0);
          } else {
            alert(res.message);
            this.loadinginfoDetail = false;
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("API 호출 오류",err)
            this.loadinginfoDetail = false;
            // alert(err);
        }
      ); 
    },
    listHistories() {
      // if (this.msgFlag) this.$store.commit("resMessage","");
      this.save_id = 0;
      this.historiesloading = true;
      Apis.listSettingHistories({
          room_cd: this.room_cd,
      } ,(res) => {  // 정상처리
        if (res.result) {
          this.items = res.data;
          // if (this.msgFlag) this.$store.commit("resMessage",res.message);
          // this.msgFlag = true;
          this.historiesloading = false;
        } else {
          console.log("listSettingHistories 자료없음",res.mag);
          this.historiesloading = false;
        }

      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("listSettingHistories 호출 오류",err);
        this.historiesloading = false;
      }) 
    }, 
    showHistories() {
      this.showhistories = ! this.showhistories;
      if (this.showhistories) this.listHistories();
      this.historiesBtnText = this.showhistories ? "이력닫기" : "이력보기";
    },
    itemRowBackground(item) {
      return item.id === this.save_id  ? 'selected' : '' ;
    },
    gotoSummary() {
      this.$router.push({
        name: "ControlMonitoring",
        params: {
          company: {code: this.company_cd, name: this.company_name},
          farm: {code: this.farm_cd, name: this.farm_name},
          building: {code: this.building_cd, name: this.building_name},
        }
      });
    },
    getRoomClass(){
      // console.log(this.control_status)
      if (this.control_status === undefined) {
        return {
          white_bg: true, // 기본값
        };
      }
      return {
        white_bg: this.control_status === 0,
        green_bg: this.control_status > 0,
        gray: this.fan_list.length === 0,
      };
    },
    getTextClass(){
      return{
        color_black: this.control_status == 0,
        color_gold:this.control_status > 0,
        color_white: this.fan_list.length == 0 
      }
    },
    getIconClass(){
      return{
        white_color: this.fan_list.length == 0 && this.control_status == '' || this.control_status > 0,
        green_color: this.remote_mode == 0  && this.fan_list.length > 0,
       
      }
    },

  }
}
</script>

<style scoped lang="scss">
@import '../../style/base.scss';
.header-button{
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 50px;
  height:45px;
  font-size:15px;
  width:125px;
  font-weight:600;
}
.set-container{
  margin-top: 15px;
  // border:1px solid #D5D5D5;
  border-radius: 5px;
  padding:10px;
}
.status-container{
  width:30vw;
  max-width: 380px;
}
.setting-containter{
  margin-left:20px;
  width:40vw;
  // max-width:700px;
}
.history-container{
  width:30vw;
  margin-left:20px;
}
.table_layout{
  min-width:50px !important;
}
.table_content{
  min-width:50px !important;
}
.room-info{
  background: #3A4F3F;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  padding:10px;
}
.text_name{
  font-size:20px;
  font-weight:600;
  margin-left:10px;
}
.text_staus{
  font-size:15px !important;
  margin-left:5px; 
}
.box_temp{
  margin-left:3px !important;
  width:45px;
}
.temp, .feel{
  font-size:17px;
}
.text_feel{
  margin-right:14px;
}
.text_number_unit{
  font-size:13px;
  margin-top:5px !important;
}
.fan-info{
  background-color: whitesmoke;
  width:100%;
  height:100%;
  padding-bottom: 10px;
  margin-bottom: 10px;
  margin-top:15px;
  margin-left:-5px;
  border-radius: 10px;
  color:#3a4f3f !important;
}
.set_info{
  display: flex;
  padding:15px 15px 0 15px;
}
.name{
  font-size:18px !important;
  font-weight:bold;
  width:85px;
}
.text_info{
  font-size:18px;
  // padding-bottom:5px;
}
.control_date{
  text-align: right;
  font-size:17px;
  color:#a3a3a3;
  margin-right:15px;
}
.set_mode{
  display: flex;
  height:65px;
  line-height:45px;
}
.control-set{
  margin-top:10px;
  border:1px solid #D5D5D5;
  border-radius: 5px;
  padding:10px;
}
.set_name{
  padding-left:10px;
  color: #808080 !important;
  font-size:17px !important;
  font-weight:bold;
  width:120px;
  letter-spacing: -1px;
}
::v-deep .v-input--radio-group__input{
  background-color: #F3F3F3 !important;
}
.selectbox ,.selectbox-cal{
  width:230px !important;
}
::v-deep .selectbox-cal{
  .v-input__slot{
    min-height:45px !important;
  }
}
.selectbox-cal{
  border-radius: 10px !important;
}
::v-deep .v-text-field__slot .v-label {
  background-color:white;
}

.fan-name{
  font-size:18px;
  font-weight: 600;
  letter-spacing: -1px;
  color:#3A4F3F;
  // width:30px;
  // margin-right:15px;
  // margin-left:15px;
}
.vent-name{
  width:30px;
}
.fc_setbox{
  background: #FFFFFF;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  padding:12px;
  margin-top:10px;
  display:flex;
  align-items: center;
  width:100%;
  // min-width:550px;
  max-width:550px;
}
.input-box{
  width:20%;
  // width:95px !important;
  height:42px !important;
  border:1px solid #c6c6c6 !important; 
  margin-right:10px !important;
}
.switch-container{
  height:45px;
  margin-top:-10px;
  align-items: center;
}
.btn-container{
  width:550px;
}
.exit_btn{
  color:#3A4F3F !important;
  border:1px solid #3A4F3F !important;
  font-weight:600;
  width:100px !important;
  height:50px !important; 
}
.save_btn{
  color:white !important;
  background-color: #3A4F3F !important;
  font-weight:600;
  width:100px !important;
  height:50px !important; 
}
.stop_btn{
  color:white !important;
  background-color: #88191A !important;
  font-weight:600;
  width:100px !important;
  height:50px !important; 
}
// 컬러
.main{
  background-color: $main-color;
  color:white;
}
.gray{
  background-color: #939393 ;
  color:white;
}

// 상태에 따라 색상 변경
.white_bg {
  background-color: white !important;
  border: solid 1px #d6d6d6 !important;
  color:#3a4f3f !important;
}
.green_bg {
  background-color: #3a4f3f !important;
}
.red {
  background-color: #88191a !important;
}
.gray {
  background-color: #aaaaaa !important;
}
.color_black {
  color: #3a4f3f !important;
}
.color_gold {
  color: #f1f595 !important;
}
.color_gray {
  color: #868686 !important;
}
.color_error {
  color: #88191a !important;
}
.color_white{
  color:white !important;
}
.white_color{
  filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%);
}
.green_color{
  filter: invert(28%) sepia(33%) saturate(338%) hue-rotate(82deg) brightness(85%) contrast(87%);
}

.loading-monitor-container{
  margin-top:15px;
  border:1px solid #D5D5D5;
  border-radius: 5px;
  height:10vh;
  display:flex;
  justify-content: center;
  align-items: center;
}
.fc{
  background-color:#3a4f3f;
  width:23px !important;
  height:23px;
  padding:3px;
  border-radius:4px;
  display: flex;
  margin-top:5px;
  margin-left:10px;
}
.fan_icon{
  width:18px !important;
}

//스위치


.switch-container {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f4f4f4;
}

/* 스위치 전체 스타일 */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
}

/* 숨겨진 체크박스 */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* 슬라이더 */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 26px;
}

/* 슬라이더 원 */
.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

/* 체크박스가 체크된 경우 */
input:checked + .slider {
  background-color: $main-color; /* 활성화 색상 (브랜드 컬러) */
}

input:checked + .slider:before {
  transform: translateX(24px);
}

.error_overlay{
  // position: absolute;
  // margin-top:5px;
  // // min-width: 55;
  // width:38.5vw;
  // min-width:435px;
  // max-width:555px;

  // height:25vh;
  // min-height: 240px;
  // max-height: 250px;
  // background-color:rgba(196, 196, 196, 0.6)  ;
  // color: white;
  // // font-weight: bold;
  // text-align: center;
  // padding: 15px;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // border-radius: 8px;
  // z-index: 10;
  // pointer-events: auto; /* 사용자가 클릭 못 하도록 설정 */
}
.setting-containter {
  position: relative; // error_overlay의 기준이 됨
  margin-left: 20px;
  width: 40vw;
}

/* error_overlay를 입력창 포함하는 크기로 조정 */
.error_overlay {
  position: absolute;
  top: 0; // 가장 위로 배치
  left: 0;
  // transform: translateX(-7%);
  width: 100%; // 부모 요소 크기 맞추기
  min-width: 435px;
  max-width: 555px;
  height: calc(100% - 420px); // 팬컨트롤러 + 1~3차 입력 높이를 포함하도록 설정
  background-color: rgba(196, 196, 196, 0.6);
  color: white;
  text-align: center;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  z-index: 10;
}
.dialog_title, .dialog_cotent{
  font-size:18px;
  color:$main-color;
  letter-spacing: -1px;
}
.dialog_title{
  font-size:20px;
  font-weight:600;
}
.dialog_cotent{ 
  margin-top:10px;
  margin-bottom: 10px;
}
.error_btn{
  background-color: $main-color;
  color:white !important;
  font-weight:600;
  border-radius: 20px;
  font-size:15px;
  height:40px !important;
  width:90px !important;
  cursor: pointer;
}
.mb-vent{
  height:45px;
}
//팬출력
.test_vent { animation: rotate_image var(--animation-duration) linear infinite; transform-origin: 50% 50%;}

@keyframes rotate_image{
    100% {
        transform: rotate(360deg);
    }
}
@media screen and (max-width: 768px) {
  .set-container{
    flex-direction: column;
  }
  .status-container{
    width:100%;
    // width: 345px;
  }
  .setting-containter{
    margin-left:-5px !important;
  }
  .set-container{
    border:none !important;
  }
  .selectbox , .selectbox-cal {
    width:200px !important;
  }
  .input-box{
    min-width:75px !important;
  }
  .fc_setbox{
    flex-direction: column;
    min-width:350px !important;
    // margin-left:-10px;
  }
  .set_name{
    width:100px;
  }
  .mb-vent{
    margin-left:5px;
  }

  ::v-deep .v-text-field__slot .v-label {
   font-size:14px !important;
  }
  .btn-container{
    min-width:300px !important;
  }
  .exit_btn , .save_btn , .stop_btn{
    min-width:80px !important;
  } 
  .history-container{
    width:100%!important;
  }
  .error_overlay{
    margin-top:5px;
    min-width:350px !important;
    height: 365px !important;
  }
  .dialog_cotent{
    font-size:15px !important;
  }
}

</style>